import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import moment from 'moment'

import CustomButton from '../../kit/components/CustomButton/CustomButton.js'
import Callout from '../../kit/components/Callout/Callout.js'

import {
  tryToGetUserLog
} from '../../actions/actions.export'

class UserEmailHistory extends Component {
  constructor(props){
    super(props);
  }

  componentDidMount(){
    const { dispatch, userReducer } = this.props;

    dispatch(tryToGetUserLog({
      type: 'email'
    }))
  }

  render(){

    const { dispatch, userReducer } = this.props;

    return <div className="box">

        <div className="flex-split margin-bottom-2rem">
          <h5 className="no-margin-top no-margin-bottom">
            Email History
          </h5>
          <div className="list-right">
            {
              (userReducer.tryingToGetUserLog === "email") ?
              <i className="far fa-spinner-third fa-spin text-muted fa-fw"/>
              :
               <i className="far fa-sync-alt clickable icon-muted-until-hover fa-fw" onClick={()=>{ 
                dispatch(tryToGetUserLog({type: 'email'}))
              }}/>
            }
          </div>
        </div>

        {
          (userReducer.log.email) && 
          <div>
            {
              userReducer.log.email.map((e, i)=>{
                return <div className="subtle-section text-smaller" key={i}>
                  {
                    (e.from && e.to) && <div className="margin-bottom-05rem">
                      <i className="far fa-random text-muted icon-before-text"/>Email changed from: <span className="text-700">{e.from}</span> to <span className="text-700">{e.to}</span>
                    </div>                    
                  }
                  {
                    e.verified && <div className="margin-bottom-05rem">
                      <i className="fas fa-check text-success icon-before-text"/>Email Verified: <span className="text-700">{e.email}</span>
                    </div>
                  }
                  <div className="list-left margin-bottom-05rem no-margin-top">
                    <span>{moment(e.timestamp).format("dddd, MMMM Do YYYY, h:mm:ss a")}</span>
                    <span className="text-very-muted">|</span>
                    <span className="text-muted">{moment(e.timestamp).fromNow()}</span>
                  </div>
                  <p className="no-margin-top no-margin-bottom">
                    IP Address: <span className="text-700">{e.req_ip}</span>
                  </p>
                </div>
              })
            }
          </div>
        }

        {
          (userReducer.log.email && !userReducer.logEmpty.email) && 
          <div className="flex-column-center">
            <CustomButton
              display="Load More"
              thinking={userReducer.tryingToGetUserLog === "email"}
              success={userReducer.getUserLogSuccess}
              fail={userReducer.getUserlogFail}
              onClick={()=>{
                dispatch(tryToGetUserLog({
                  type: 'email',
                  startAfter: userReducer.log.email[userReducer.log.email.length - 1].id
                }))
              }}
              />
          </div>
        }
        {
          userReducer.logEmpty.email &&
          <p className="text-center text-muted text-smaller">
            You've reached the end of the log.
          </p>
        }

    </div>
  }
}


const mapStateToProps = (state) => {
  const { userReducer } = state;

  return {
    userReducer
  }
}

export default connect(mapStateToProps)(UserEmailHistory);
